const house = {
    bidSectionCode: '标段编号',
    bidSectionName: '标段名称'
}
export default house
